import React, {Component} from 'react';
import '../../pages/settingsPage/SettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import models from '../../model/models';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import Integrations from "../settingsPage/Integrations/Integrations";
import SettingsTabBar from '../../components/settingsTabBar/SettingsTabBar';

export default class IntegrationsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_group: {},
			integrations: [],
		};
	}

	componentDidMount = async () => {
		this.subscribeId = models.user_group.onChange(this._getData);
		await this.refreshIntegrations();
	};

	componentWillUnmount = () => {
		if (this.subscribeId) {
			models.user_group.unsubscribe(this.subscribeId);
		}
	};

	fetchIntegrations = async () => {
		try {
			const result = [];
			const integrations = await mainAPI.integration.all() || [];
			const {name, enabled: isEnabled} = integrations.find(({name}) => name === 'NarcLock');
			if (name) {
				const [{
					credentials: {
						account = '',
						password = '',
						email = ''
					} = {}
				} = {}
				] = await mainAPI.narc_lock_integration.get() || [];
				console.log(`Retrieved '${name}' integration details.`);
				result.push({name, isEnabled, account, email, password});
			}
			return result;
		} catch (error) {
			console.error('Error fetching NarcLock integrations and setting state.', error)
			return [];
		}
	};

	refreshIntegrations = async (_integrations = []) => {
		const integrations = await this.fetchIntegrations();
		this.setState({integrations});
	};

	_getData = async () => {
		let user_group = models.user_group.obj();
		if (!user_group) return;
		await userGroupSettingsManager.refresh(user_group.id);
		this.setState({user_group});
	};

	render() {
		const {integrations = []} = this.state;
		return (
			<Page className="g-settings-page">
				<Card>
					<Label larger black>
						Account settings
					</Label>
					<div className="lower">
						<SettingsTabBar userGroup={this.state.user_group} />
						<Integrations integrations={integrations} onUpdate={this.refreshIntegrations} />
					</div>
				</Card>
			</Page>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/integrationsPage/IntegrationsPage.jsx